var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex flex-col p-2 rounded-xl",
      class: {
        "bg-slate-300":
          _vm.target.target_tasks && _vm.target.target_tasks.length > 0
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "bl-target",
          class: [
            _vm.active && !_vm.target.target_tasks ? "bl-target-active" : "",
            _vm.active && !_vm.activeTask > 0 ? "bl-target-active" : "",
            _vm.target.target_tasks && _vm.target.target_tasks.length > 0
              ? "mb-2"
              : ""
          ]
        },
        [
          _c("div", {
            staticClass: "pointer-events-none bl-target-border",
            style: { backgroundColor: _vm.target.curriculum_color || "#EAECF0" }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "bl-target-container bg-pure-white",
              class: [
                _vm.useAction ? "hover:border-light-purple cursor-pointer" : ""
              ],
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("clicked", _vm.target.id)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "bl-target-header" },
                [
                  _c("BlTextBody2", {
                    staticClass: "truncate bl-target-description",
                    attrs: { text: _vm.target.curriculum_name }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bl-target-actions" },
                    [
                      _vm.checkPassedActionRecommendation(_vm.target) &&
                      _vm.target.status !== "mastered"
                        ? _c(
                            "div",
                            {
                              staticClass: "p-1 bg-orange-300",
                              style: { borderRadius: "4px" }
                            },
                            [
                              _c("BlIcon", {
                                staticClass: "w-4 h-4",
                                attrs: { icon: "tooltip" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.target.status
                        ? _c("StatusChip", {
                            staticClass: "text-xs",
                            attrs: { status: _vm.target.status }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.useAction
                        ? _c("BlInputButton", {
                            staticClass:
                              "flex items-center justify-center w-6 h-6 hover:bg-hover-state",
                            attrs: { icon: "dots-vertical", type: "plain" },
                            on: {
                              clicked: function($event) {
                                _vm.opened = true
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mt-2 bl-target-body" },
                [
                  _c("BlTextSubtitle2", {
                    staticClass: "truncate bl-target-name",
                    attrs: { text: _vm.target.name }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.opened
            ? _c(
                "div",
                {
                  staticClass: "bl-target-dropdown",
                  attrs: { "data-id": _vm.id }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "bl-target-dropdown-body",
                      attrs: { "data-id": _vm.id }
                    },
                    _vm._l(_vm.options, function(option, i) {
                      return _c(
                        "div",
                        {
                          key: i,
                          staticClass: "bl-target-dropdown-option",
                          attrs: { "data-id": _vm.id },
                          on: {
                            click: function($event) {
                              return _vm.$emit(option.event)
                            }
                          }
                        },
                        [
                          _c("BlIcon", {
                            staticClass: "bl-target-dropdown-option-icon",
                            attrs: {
                              icon: option.icon,
                              color: option.type || "default"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "bl-target-dropdown-option-name",
                              class:
                                "bl-target-dropdown-option-name-" + option.type
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(option.name) +
                                  "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.target.target_tasks && _vm.target.target_tasks.length > 0
        ? _c(
            "div",
            { staticClass: "flex flex-col gap-3" },
            _vm._l(_vm.target.target_tasks, function(item, i) {
              return _c(
                "div",
                { key: item.id, staticClass: "flex items-center gap-3" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center flex-shrink-0 w-2 h-2 text-sm font-medium rounded-full top-2 -left-12 bg-slate-600"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "relative flex flex-col items-center justify-center"
                        },
                        [
                          i !== _vm.target.target_tasks.length - 1
                            ? _c("div", {
                                staticClass:
                                  "absolute transform h-9 top-2 bg-slate-600",
                                staticStyle: { width: "1px" }
                              })
                            : _vm._e()
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-between w-full p-2 overflow-hidden rounded bg-pure-white",
                      class: {
                        "cursor-pointer": !_vm.isFromSession,
                        "border border-light-purple":
                          _vm.activeTask && _vm.activeTask.id === item.id,
                        "border border-pure-white":
                          !_vm.activeTask || _vm.activeTask.id !== item.id
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.$emit("clickedTask", item, _vm.target.id)
                        }
                      }
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "truncate text-slate-1000",
                        attrs: { text: item.code + " - " + item.title }
                      })
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ac5cabf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac5cabf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/Card.vue
// module id = null
// module chunks = 